import { get } from '../../../../helpers/fetch';
import { buildURL } from '../../../../helpers/urls';

export const getImageMiningFacesData = async (snapshotId) => {
  const url = buildURL(`/snapshots/${snapshotId}/facesData`);
  return get(url);
};

export const getUserData = async (userId, slugDate) => {
  const query = slugDate ? `?${new URLSearchParams({ slugDate }).toString()}` : '';
  const url = buildURL(`/users/${userId}/stats${query}`);
  return get(url);
};
